import {
  BaseQueryFn,
  EndpointBuilder,
  QueryDefinition,
} from '@reduxjs/toolkit/query';

import type {
  IFileResourceArgs,
  IFileResourceData,
} from './fileResources.api.types';

// Any file resource, fetched by its path. Only used by helpers/file/fileBinary,
// which resolves every file binary read. Components keep using the typed
// per-resource endpoints for the resource's own data.
export const getFileResource = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<IFileResourceArgs, BaseQueryFn, string, IFileResourceData> =>
  build.query<IFileResourceData, IFileResourceArgs>({
    query: (queryArg) => ({
      url: queryArg.resourcePath,
    }),
  });
